import { styled } from '@mui/material/styles';

export const FormRow = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
  '&:last-child': { marginBottom: theme.spacing(0) },
}));

export const FormRowItem = styled('p')({ margin: 0 });
